export const list = {
  table: {
    tankNo: 'Tank No',
    detergentName: 'Detergent Name',
    method: 'Method',
    netWeightMl: 'Net weight ml',
    thresholdQuantity: 'Threshold quantity',
    remainingQuantity: 'Remaining quantity',
    usedQuantity: 'Used quantity',
    manual: 'Manual',
    automatic: 'Automatic',
  },
  buttonAction: {
    importAdd: 'Import (Add)',
    importOverwrite: 'Import (Overwrite)',
    export: 'Export',
    update: 'Update',
  },
  pageHeader: {
    title: 'Tanks List',
    titleDetergentsList: 'Personal data registration/editing',
    new: 'New',
  },
}
